import * as React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useEffect } from "react";
import axios from "axios";
import "./ManagementModal.scss";

import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { errorToast, successToast } from "../../common/ToastMessage";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

export default function ManagementModal({ open, close, managementid, isAdd, managmentData, getissueManagementDetails, setLoaderActive }) {
    const [monitorname, setMonitorName] = React.useState('');
    const [monitornameid, setMonitorNameId] = React.useState([]);
    const [cpuname, setCPUName] = React.useState('');
    const [cpunameid, setCPUNameId] = React.useState([]);
    const [keyboardname, setKeyBoardName] = React.useState('');
    const [keyboradnameid, setKeyBoradNameId] = React.useState([]);
    const [mousename, setMouseName] = React.useState('');
    const [mousenameid, setMouseNameId] = React.useState([]);
    const [headphonename, setHeadPhoneName] = React.useState('');
    const [headphonenameid, setHeadPhoneNameId] = React.useState([]);
    const [cameraname, setCameraName] = React.useState('');
    const [cameranameid, setCameraNameId] = React.useState([]);
    const [employeename, setEmployeeName] = React.useState("");
    const [employeemailid, setEmployeeMailId] = React.useState("");
    const [assignprojectname, setAssignProjectName] = React.useState("");
    const [dateofissue, setDateOfIssue] = React.useState();
    const [password, setPassword] = React.useState("");
    const [designation, setDesignation] = React.useState("");
    const [brands, setBrands] = React.useState([]);

    const [error, setError] = React.useState([]);
    const handleChange = (newValue) => {
        setDateOfIssue(dayjs(newValue).format());
    };


    useEffect(() => {
        window.scrollTo(0, 0);
        getAllData();
        getBrandName();
    }, []);

    useEffect(() => {
        if (!isAdd) {
            setManagementData();
        } else {
            setDateOfIssue(new Date())
        }
    }, [managementid]);

    const setManagementData = () => {
        setEmployeeName(managmentData?.employeeName);
        setEmployeeMailId(managmentData?.employEmailId);
        setAssignProjectName(managmentData?.assignProjectName);
        setDateOfIssue(managmentData?.dateOfIssue);
        setPassword(managmentData?.password);
        setDesignation(managmentData?.designation);
        setMonitorName(managmentData?.monitorId);
        setCPUName(managmentData?.cpuId);
        setKeyBoardName(managmentData?.keybordId);
        setMouseName(managmentData?.mouseId);
        setHeadPhoneName(managmentData?.headphoneId);
        setCameraName(managmentData?.cameraId);
    }
    const saveManagement = async () => {
        if (validateForm()) {
            setLoaderActive(true);
            const headers = {
                Authorization: "Bearer " + localStorage.getItem("_token"),
                "Content-type": "application/json",
            };
            if (isAdd) {
                let item = {
                    employeeName: employeename,
                    employEmailId: employeemailid,
                    assignProjectName: assignprojectname,
                    dateOfIssue: dateofissue,
                    password: password,
                    designation: designation,
                    role: 'Employee',
                    ...(monitorname !== "") && { monitor: monitorname },
                    ...(cpuname !== "") && { cpu: cpuname },
                    ...(keyboardname !== "") && { keybord: keyboardname },
                    ...(mousename !== "") && { mouse: mousename },
                    ...(headphonename !== "") && { headPhone: headphonename },
                    ...(cameraname !== "") && { camera: cameraname },
                }
                axios.post(`${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Management`, item,
                    {
                        headers: headers,
                    })
                    .then(function (response) {
                        console.log("response add-", response);

                        if (response?.status == '200') {
                            if (response?.data?.message == 'Email Already exist') {
                                setError({ ...error, employeemailid: response?.data?.message })
                                errorToast(response?.data?.message)
                                setLoaderActive(false);
                            } else {
                                close();
                                successToast(response?.data?.message)
                                getissueManagementDetails();
                            }
                        }
                    })
                    .catch(function (error) {
                        console.log('error', error);
                        setLoaderActive(false);
                        if (error?.response?.status === 401) {
                            errorToast(error?.response?.statusText)
                        } else {
                            errorToast(error?.message)
                        }
                    });

            } else {

                let updatepayload = {
                    managementId: managmentData?.managementId,
                    employeeName: employeename,
                    employEmailId: employeemailid,
                    password: password,
                    designation: designation,
                    assignProjectName: assignprojectname,
                    dateOfIssue: dateofissue,
                    role: "Employee",
                    ...(monitorname !== "") && { monitor: monitorname },
                    ...(cpuname !== "") && { cpu: cpuname },
                    ...(keyboardname !== "") && { keybord: keyboardname },
                    ...(mousename !== "") && { mouse: mousename },
                    ...(headphonename !== "") && { headPhone: headphonename },
                    ...(cameraname !== "") && { camera: cameraname },
                }
                // Update Api
                axios.post(`${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Management/Update`, updatepayload,
                    {
                        headers: headers,
                    })
                    .then(function (response) {
                        console.log("response update -", response);

                        if (response?.data?.message == 'Email Already exist') {
                            setError({ ...error, employeemailid: response?.data?.message })
                            errorToast(response?.data?.message)
                            setLoaderActive(false);
                        } else {
                            close();
                            successToast(response?.data?.message)
                            getissueManagementDetails();
                        }
                    })
                    .catch(function (error) {
                        console.log('error', error);
                        setLoaderActive(false);
                        if (error?.response?.status === 401) {
                            errorToast(error?.response?.statusText)
                        } else {
                            errorToast(error?.message)
                        }
                    });
            }
        }
    }

    const getAllData = async () => {
        const headers = {
            Authorization: "Bearer " + localStorage.getItem("_token"),
            "Content-type": "application/json",
        };
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Management/GetAllAppliances`,
                {
                    headers: headers,
                }
            );

            setMonitorNameId(response?.data?.data?.moniter);
            setCPUNameId(response?.data?.data?.cpu);
            setKeyBoradNameId(response?.data?.data?.keyboard);
            setMouseNameId(response?.data?.data?.mouse);
            setHeadPhoneNameId(response?.data?.data?.headphone);
            setCameraNameId(response?.data?.data?.camera);
        } catch (error) {
            console.log(error);
            if (error?.response?.status === 401) {
                errorToast(error?.response?.statusText)
            } else {
                errorToast(error?.message)
            }
        }
    };
    const getBrandName = async () => {
        const headers = {
            Authorization: "Bearer " + localStorage.getItem("_token"),
            "Content-type": "application/json",
        };
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Appliance/GetBrandName`,
                {
                    headers: headers,
                }
            );
            setBrands(response.data.data);
        } catch (error) {
            console.log(error);
            if (error?.response?.status === 401) {
                errorToast(error?.response?.statusText)
            } else {
                errorToast(error?.message)
            }
        }
    };
    const handleChangeMonitorId = (event) => {
        setMonitorName(event.target.value);
    }
    const handleChangeCPUId = (event) => {
        setCPUName(event.target.value);
    }
    const handleChangeKeyBoardId = (event) => {
        setKeyBoardName(event.target.value);
    }
    const handleChangeMouseId = (event) => {
        setMouseName(event.target.value)
    }
    const handleChangeHeadPhoneId = (event) => {
        setHeadPhoneName(event.target.value)
    }
    const handleChangeCameraId = (event) => {
        setCameraName(event.target.value)
    }
    const validateForm = () => {
        setError([]);
        let error = {}
        // let email_pattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
        let email_pattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
        // let pass_pattern = /^(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/;
        let pass_pattern = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;

        if (!employeename) {
            error.employeename = "Employee Name is required."
        }
        if (!employeemailid) {
            error.employeemailid = "E-Mail ID is required."
        }
        if (!assignprojectname) {
            error.assignprojectname = "Assigned Project Name is required."
        }
        if (!password) {
            error.password = "Password is required."
        }
        if (!pass_pattern.test(password)) {
            error.password = "Password must be at least 8 characters long and contain at least one digit,one special character and one uppercase letter."
        }


        if (!designation) {
            error.designation = "Designation is required."
        }
        if (!email_pattern.test(employeemailid)) {
            error.employeemailid = "Please enter Valid E-Mail ID."
        }


        if (Object.keys(error).length > 0) {
            setError(error);
            return false;
        }
        return true;
    }

    const getBrandNameValue = (applianceData) => {
        const selectedBrand = brands?.find((item) => {
            return item?.brandId == applianceData?.brandId
        })
        return selectedBrand?.brandName
    }

    return (
        <div>
            <BootstrapDialog
                className="management-modal-wrap modal-wrap"
                onClose={() => close()}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <BootstrapDialogTitle
                    id="customized-dialog-title"
                    onClose={() => close()}
                >
                    {isAdd ? 'Add' : 'Edit'} User
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="txtfield-wrap">
                                <TextField
                                    error={error && error.employeename}
                                    id="outlined-required"
                                    fullWidth
                                    label=" Name"
                                    value={employeename}
                                    onChange={(e) => { setError([]); setEmployeeName(e.target.value) }}
                                    helperText={error.employeename}
                                />
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="txtfield-wrap">
                                <TextField
                                    error={error && error.employeemailid}
                                    id="outlined-required1"
                                    fullWidth
                                    label=" E-Mail ID"
                                    onChange={(e) => { setError([]); setEmployeeMailId(e.target.value) }}
                                    helperText={error.employeemailid}
                                    value={employeemailid}
                                    type="email"
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="txtfield-wrap">
                                <TextField
                                    error={error && error.assignprojectname}
                                    id="outlined-required2"
                                    fullWidth
                                    label="Assigned Project"
                                    value={assignprojectname}
                                    onChange={(e) => { setError([]); setAssignProjectName(e.target.value) }}
                                    helperText={error.assignprojectname}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="txtfield-wrap">
                                {/* <TextField
                                        id="outlined-required"
                                        fullWidth
                                        label="Date of issue"
                                        onChange={(e) => setDateOfIssue(e.target.value)}
                                        /> */}
                                <LocalizationProvider dateAdapter={AdapterDayjs} sx={{ width: "100%" }}>
                                    <MobileDatePicker
                                        fullWidth
                                        label="Date of Provided Appliances"
                                        inputFormat="DD/MM/YYYY"
                                        value={dateofissue}
                                        onChange={(e) => { setError([]); handleChange(e) }}
                                        renderInput={(params) => <TextField {...params} />}
                                    />
                                </LocalizationProvider>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="txtfield-wrap">
                                <TextField
                                    error={error && error.password}
                                    id="outlined-required3"
                                    fullWidth
                                    label="Password"
                                    value={password}
                                    onChange={(e) => { setError([]); setPassword(e.target.value) }}
                                    helperText={error.password}
                                />
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="txtfield-wrap">
                                <TextField
                                    error={error && error.designation}
                                    id="outlined-required4"
                                    fullWidth
                                    label="Designation"
                                    value={designation}
                                    onChange={(e) => { setError([]); setDesignation(e.target.value) }}
                                    helperText={error.designation}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="txtfield-wrap">
                                <FormControl fullWidth
                                    sx={{
                                        "& .MuiOutlinedInput-root": { mb: 2 },
                                    }}>
                                    <InputLabel id="demo-simple-select-label">Monitor</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label=" Monitor"
                                        value={monitorname}
                                        onChange={handleChangeMonitorId}
                                    >
                                        {monitornameid && monitornameid.map((item, i) => {
                                            return (
                                                <MenuItem key={`monitor-${i + 1}`} value={item?.applianceId} className={item?.isAssign == 0 ? "occupied" : "unoccupied"} disabled={item?.isAssign == 0 ? false : true}>{item?.applianceCode} - {getBrandNameValue(item)}</MenuItem>
                                            )
                                        })}
                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="txtfield-wrap">
                                <FormControl fullWidth
                                    sx={{
                                        "& .MuiOutlinedInput-root": { mb: 2 },
                                    }}>
                                    <InputLabel id="demo-simple-select-label">CPU</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label="CPU"
                                        value={cpuname}
                                        onChange={handleChangeCPUId}
                                    >
                                        {cpunameid && cpunameid.map((item, i) => {
                                            return (
                                                <MenuItem key={`cpu-${i + 1}`} value={item?.applianceId} className={item?.isAssign == 0 ? "occupied" : "unoccupied"} disabled={item?.isAssign == 0 ? false : true}>{item?.applianceCode} - {getBrandNameValue(item)}</MenuItem>
                                            )
                                        })}
                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="txtfield-wrap">
                                <FormControl fullWidth
                                    sx={{
                                        "& .MuiOutlinedInput-root": { mb: 2 },
                                    }}>
                                    <InputLabel id="demo-simple-select-label">Key Board</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label="Key Board"
                                        value={keyboardname}
                                        onChange={handleChangeKeyBoardId}
                                    >
                                        {keyboradnameid && keyboradnameid.map((item, i) => {
                                            return (
                                                <MenuItem key={`keyboard-${i + 1}`} value={item?.applianceId} className={item?.isAssign == 0 ? "occupied" : "unoccupied"} disabled={item?.isAssign == 0 ? false : true}>{item?.applianceCode} - {getBrandNameValue(item)}</MenuItem>
                                            )
                                        })}
                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="txtfield-wrap">
                                <FormControl fullWidth
                                    sx={{
                                        "& .MuiOutlinedInput-root": { mb: 2 },
                                    }}>
                                    <InputLabel id="demo-simple-select-label">Mouse</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label="Mouse"
                                        value={mousename}
                                        onChange={handleChangeMouseId}
                                    >
                                        {mousenameid && mousenameid.map((item, i) => {
                                            return (
                                                <MenuItem key={`mouse-${i + 1}`} value={item?.applianceId} className={item?.isAssign == 0 ? "occupied" : "unoccupied"} disabled={item?.isAssign == 0 ? false : true}>{item?.applianceCode} - {getBrandNameValue(item)}</MenuItem>
                                            )
                                        })}

                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="txtfield-wrap">
                                <FormControl fullWidth
                                    sx={{
                                        "& .MuiOutlinedInput-root": { mb: 2 },
                                    }}>
                                    <InputLabel id="demo-simple-select-label">Head Phone</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label="Head Phone"
                                        value={headphonename}
                                        onChange={handleChangeHeadPhoneId}
                                    >
                                        {headphonenameid && headphonenameid.map((item, i) => {
                                            return (
                                                <MenuItem key={`headphone-${i + 1}`} value={item?.applianceId} className={item?.isAssign == 0 ? "occupied" : "unoccupied"} disabled={item?.isAssign == 0 ? false : true}>{item?.applianceCode} - {getBrandNameValue(item)}</MenuItem>
                                            )
                                        })}

                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="txtfield-wrap">
                                <FormControl fullWidth
                                    sx={{
                                        "& .MuiOutlinedInput-root": { mb: 2 },
                                    }}>
                                    <InputLabel id="demo-simple-select-label">Camera</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label="Camera"
                                        value={cameraname}
                                        onChange={handleChangeCameraId}
                                    >
                                        {cameranameid && cameranameid.map((item, i) => {
                                            return (
                                                <MenuItem key={`camera-${i + 1}`} value={item?.applianceId} className={item?.isAssign == 0 ? "occupied" : "unoccupied"} disabled={item?.isAssign == 0 ? false : true}>{item?.applianceCode} - {getBrandNameValue(item)}</MenuItem>
                                            )
                                        })}

                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions className="btns-wrapper">
                    <Stack spacing={4} direction="row" className="bottom-btn-wrap">

                        <Button onClick={() => { setError([]); saveManagement() }} variant="outlined">{isAdd ? 'Save' : 'Update'}</Button>
                        <Button variant="outlined" onClick={() => close()}>Cancel</Button>

                    </Stack>
                </DialogActions>
            </BootstrapDialog>
        </div>
    );
}
